export function suppressResizeObserverError() {
  const suppressError = (event: ErrorEvent | PromiseRejectionEvent) => {
    const message = event instanceof ErrorEvent ? event.message : event.reason?.message

    if (message?.includes('ResizeObserver loop completed with undelivered notifications')) {
      // Prevent the error from appearing in the console
      event.preventDefault()

      // Optional: Log a custom message
      console.warn('Suppressed ResizeObserver error:', message)
    }
  }

  if (typeof window !== 'undefined') {
    window.addEventListener('error', suppressError)
    window.addEventListener('unhandledrejection', suppressError)
  }

  return () => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('error', suppressError)
      window.removeEventListener('unhandledrejection', suppressError)
    }
  }
}
